export const CHART_LOG_FLOOR = 0.01;
export const CHART_EDGE_THRESHOLD = 20;
export function logPosition(value, min, max) {
    const safeVal = Math.max(value, CHART_LOG_FLOOR);
    const safeMin = Math.max(min, CHART_LOG_FLOOR);
    const safeMax = Math.max(max, CHART_LOG_FLOOR);
    const logMin = Math.log10(safeMin);
    const logMax = Math.log10(safeMax);
    if (logMax === logMin)
        return 50;
    return Math.min(100, Math.max(0, ((Math.log10(safeVal) - logMin) / (logMax - logMin)) * 100));
}
export const focusRingSx = (theme) => ({
    "&:focus-visible": {
        outline: `2px solid ${theme.palette.secondary.main}`,
        outlineOffset: -2,
    },
});
